import React from "react";

const PHRASE = "THE WORLD NEEDS WHAT YOU HAVE TO SAY. LET'S GET YOU READY.";

export default function Marquee() {
  const items = Array.from({ length: 8 });
  return (
    <section aria-hidden="true" className="bg-[#fdfaf5] border-y border-[#e9dfce] overflow-hidden">
      <div className="py-8 md:py-10 whitespace-nowrap">
        <div className="animate-marquee inline-flex gap-10">
          {items.map((_, i) => (
            <span key={i} className="font-serif-display italic text-3xl md:text-5xl text-[#1a1a1a]/85">
              {PHRASE} <span className="text-[#c9a961]">—</span>
            </span>
          ))}
          {items.map((_, i) => (
            <span key={"b" + i} className="font-serif-display italic text-3xl md:text-5xl text-[#1a1a1a]/85">
              {PHRASE} <span className="text-[#c9a961]">—</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
